export default "__VITE_ASSET__0cqeq6Pq__"